import { default as OpportunitiesFutureToggle } from './OpportunitiesFutureToggle';

export default OpportunitiesFutureToggle;
